// extracted by mini-css-extract-plugin
export default {"container":"image-and-video-toggle-module__container--tuPK8","tabsText":"image-and-video-toggle-module__tabsText--BsqDD","tabsIcon":"image-and-video-toggle-module__tabsIcon--kiNLh"};